import { IEmployeeApiService } from "services/models/ApiService";

export class MockEmployeeApiService implements IEmployeeApiService {
  getPermissions(): Promise<string[]> {
    return Promise.resolve([""]);
  }
}
